import { Selection } from './selection';

const COOKIE_KEY = 'dashboard_selection';
const MAX_AGE = 365 * 24 * 60 * 60;

// prettier-ignore
function isValidSelection(value: unknown): value is Selection {
    if (typeof value !== 'object' || value === null) return false;
    const v = value as Record<string, unknown>;
    if (v.kind === 'node'    ) return typeof v.nodeId     === 'number';
    if (v.kind === 'location') return typeof v.locationId === 'number' && typeof v.nodeId === 'number';
    if (v.kind === 'device'  ) return typeof v.deviceId   === 'number' && typeof v.nodeId === 'number';
    if (v.kind === 'kosa'    ) return typeof v.kosaId     === 'number';
    return false;
}

export function readSelectionCookie(): Selection | null {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_KEY}=([^;]+)`));
    if (!match) return null;
    try {
        const parsed = JSON.parse(decodeURIComponent(match[1]));
        return isValidSelection(parsed) ? parsed : null;
    } catch {
        return null;
    }
}

export function writeSelectionCookie(sel: Selection) {
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(JSON.stringify(sel))}; path=/; max-age=${MAX_AGE}`;
}
